import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { Card } from "@/app/admin/_common/ui/card";

export default function GuestDetailSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i} className="rounded-md p-3.5 shadow-none">
            <Skeleton className="mb-2 h-3 w-20" />
            <Skeleton className="mb-2 h-5 w-16" />
            <Skeleton className="h-3 w-24" />
          </Card>
        ))}
      </div>

      <div className="flex flex-col gap-3 md:flex-row">
        <div className="flex min-w-0 flex-col gap-3 md:basis-1/2">
          <Card className="rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
            <Skeleton className="mb-5 h-4 w-16 sm:mb-3" />
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} className="h-3 w-28" />
              ))}
            </div>
          </Card>
          <Card className="rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
            <Skeleton className="mb-5 h-4 w-16 sm:mb-3" />
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 py-2">
                <Skeleton className="size-2 flex-none rounded-full" />
                <Skeleton className="h-3 flex-1" />
              </div>
            ))}
          </Card>
        </div>
        <div className="flex min-w-0 flex-col gap-3 md:basis-1/2">
          <Card className="rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
            <Skeleton className="mb-5 h-4 w-16 sm:mb-3" />
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 border-b border-border/50 py-2 last:border-0">
                <Skeleton className="size-9 flex-none rounded-md" />
                <Skeleton className="h-3 flex-1" />
                <Skeleton className="h-3 w-16" />
              </div>
            ))}
          </Card>
          <Card className="rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
            <Skeleton className="mb-5 h-4 w-16 sm:mb-3" />
            <Skeleton className="h-16 w-full" />
          </Card>
        </div>
      </div>
    </div>
  );
}
